import TicketValidationForm from './TicketValidationForm';

export default TicketValidationForm;
